import { Merchant as ApiMerchant } from '@vendasta/billing';

export interface Merchant {
  merchantId: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  emailAddress: string;
  phoneNumber: string;
  contactName: string;
  companyName: string;
  autoPostInvoices: boolean;
  autoChargeInvoices: boolean;
  includeInFinancialRecords: boolean;
  additionalEmailAddresses: string[];
  stripeConnectId: string;
}

export function MerchantFromAPI(proto: ApiMerchant): Merchant {
  return {
    merchantId: proto.merchantId,
    address: proto.address,
    city: proto.city,
    state: proto.state,
    country: proto.country,
    zipCode: proto.zipCode,
    emailAddress: proto.emailAddress,
    phoneNumber: proto.phoneNumber,
    contactName: proto.contactName,
    companyName: proto.companyName,
    autoPostInvoices: proto.autoPostInvoices,
    autoChargeInvoices: proto.autoChargeInvoices,
    includeInFinancialRecords: proto.includeInFinancialRecords,
    additionalEmailAddresses: proto.additionalEmailAddresses || [],
    stripeConnectId: proto.stripeAccountId,
  };
}
